export enum ImportChangeState {
    New = 'CHANGE_STATE_NEW',
    Changed = 'CHANGE_STATE_CHANGED',
    Delete = 'CHANGE_STATE_DELETE',
    Unchanged = 'CHANGE_STATE_UNCHANGED',
}
